import { Controller } from "@hotwired/stimulus"

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default class extends Controller {
  static targets = ["input", "error"]
  static values = { createUrl: String, csrf: String }

  onKeydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.flushInput()
    }
  }

  onBlur() {
    this.flushInput()
  }

  onPaste(event) {
    const text = event.clipboardData?.getData("text") ?? ""
    if (text.includes(",") || text.includes("\n")) {
      event.preventDefault()
      this.addEmails(text.split(/[,\n]/))
    }
  }

  flushInput() {
    const value = this.inputTarget.value
    if (!value.trim()) return
    this.addEmails(value.split(/[,\n]/))
    this.inputTarget.value = ""
  }

  async addEmails(raw) {
    const emails = [
      ...new Set(raw.map((s) => s.trim().toLowerCase()).filter(Boolean)),
    ]
    const valid = emails.filter((e) => EMAIL_RE.test(e))
    const invalid = emails.filter((e) => !EMAIL_RE.test(e))

    if (invalid.length) {
      this.showError(
        `${valid.length} added · ${invalid.length} skipped (${invalid[0]}${invalid.length > 1 ? ", …" : ""})`,
      )
    } else {
      this.hideError()
    }

    for (const email of valid) {
      await this.postOne(email)
    }
  }

  async postOne(email) {
    const fd = new FormData()
    fd.append("season_guest[email]", email)
    fd.append("authenticity_token", this.csrfValue)
    const res = await fetch(this.createUrlValue, {
      method: "POST",
      headers: { Accept: "text/vnd.turbo-stream.html" },
      body: fd,
    })
    const html = await res.text()
    Turbo.renderStreamMessage(html)
    if (!res.ok) {
      const m = html.match(/<div>([^<]+)<\/div>/)
      if (m) this.showError(m[1])
    }
  }

  showError(msg) {
    this.errorTarget.textContent = msg
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
